import { ProfitSummary } from '../../../models/profit/profit.model';
import { useGet } from '../../useApi';

// GET /admin/profit/summary?group=day|user|bill_type&from&to
const useProfitSummary = () => {
  const { data, loading, fetch } = useGet<ProfitSummary>('Failed to load profit');
  return {
    summary: data,
    loading,
    fetchSummary: (group: string, from?: string, to?: string) => fetch('api/v1/admin/profit/summary', { group, from, to }),
  };
};

export default useProfitSummary;
